<template>
    <div style="text-align: left">
        <el-link style="text-align: left; font-size: 24px" :href="refUrl" target="_blank" type="primary"><i class="el-icon-link"></i>打开链接</el-link>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// 用于自定义菜单节点
export default {
    name: `SectionLayoutExtralPageNoFrame`,
    data() {
        return {
            title: `第三方页面`,
            refUrl: this.$route.query.source,
            token: this.$route.query.token,
            layoutExtralPageNoFrameModel: this.$root.LayoutExtralPageNoFrameModel,
            from: this.$route.query.from,
            extralPageUrlMode: this.$root.ExtralPageUrlMode,
            userInfo: {}
        }
    },
    mounted() {

    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.loadUserInfo()
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        containerHeight() {
            return `${this.screenHeight - 120}px`
        }
    },
    methods: {
        loadUserInfo() {
            if (this.currentUser && this.currentUser.dic_worker_id) {
                this.myaxios
                    .get(`/api/AcisSystem/Worker/Get/${this.currentUser.dic_worker_id}`)
                    .then(data => {
                        this.userInfo = data
                    }).then(data => {
                        this.setRefurl()
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
        setRefurl() {
            if (!this.refUrl) return null
            let refUrl = this.refUrl
            if (this.from != `google`) {
                refUrl = decodeURIComponent(refUrl)
            }
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    let str = `@${key}` + jmType
                    var encode = eval(`/` + str + `/g`)
                    refUrl = refUrl.replace(encode, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.extralPageUrlMode == `1` && !_.includes(refUrl, `doccenter`)) {
                if (refUrl.indexOf(`?`) > -1) {
                    let refstr = refUrl.split(`?`)
                    refUrl = refstr[0] + `?` + encodeURIComponent(refUrl.replace(refstr[0] + `?`, ``))
                }
            }

            if (this.userInfo) {
                _.each(this.userInfo, (value, key) => {
                    let str = `@${key}` + jmType
                    var encode = eval(`/` + str + `/g`)
                    refUrl = refUrl.replace(encode, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            this.refUrl = refUrl
            console.log(this.refUrl)
            return refUrl
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.refUrl = newUrl.query.source
            this.loadUserInfo()
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/components/SectionLayoutExtralPageNoFrame.vue